import { jsx as _jsx } from "react/jsx-runtime";
import './LoadingBar.scss';
const LoadingBar = ({ loading }) => {
    return (_jsx("div", { className: "helix-react-ai-bar-container", children: _jsx("div", { className: `bar-fill ${loading ? 'animate' : ''}` }) }));
};
export default LoadingBar;
